import {useState} from 'react';
import PortletBody from '../../../app/components/portlet/PortletBody';
import Portlet from '../../../app/components/portlet/Portlet';
import styled from 'styled-components';
import { StyledLabel } from '../../../assets/styledComponents/Global';
import Table from '../../../app/components/table/Table';
import PaginationPerPage from '../../../app/components/pagination/PaginationPerPage';
import { useGetScheduleReportExecutionQuery } from '../reportingApiSlice';
import { LISTING_PER_PAGE } from '../../../config';
import moment from 'moment';
import theme from '../../../utils/themes';
import ExecutionIcon from '../../../app/components/svgIcons/ExecutionIcon';
import ReportFailedIcon from '../../../app/components/svgIcons/ReportFailedIcon';
import EmptyState from '../../../app/components/nodata/EmptyState';
import EllipticalLoader from '../../../app/components/loader/EllipticalLoader';
import TickIcon from '../../../app/components/svgIcons/TickIcon';
import StyledToolTip from '../../../app/components/styledComponents/StyledToolTip';

const ExecutionLog = ({reportId}) => {
 
   const initialFilters = {
     perPage: LISTING_PER_PAGE,
     page: 0,
     sortedColumn: { path: 'start_dttm', order: 'desc' },
     query: '',
   };

   const [filters, setFilters] = useState({ ...initialFilters });

 const {
     data: reportingList,
     isFetching,
   } = useGetScheduleReportExecutionQuery(
     {
       perPage: filters.perPage,
       page: filters.page,
       id:reportId,
       sort: filters?.sortedColumn?.path || filters.sort,
      sortDir: filters?.sortedColumn?.order.toLowerCase()  || filters.sortDir,
     },
     {
      skip:!reportId,
       refetchOnMountOrArgChange: true,
     },
   );

     //eslint-disable-next-line
 const [columns, setColumns] = useState([
   {
        id: 1,
        label: 'State',
        alignBody: 'text-center align-middle ps-3',
        alignHeader: 'text-left align-middle cursor-pointer ps-4',
        content: (report) => (
          <div className="d-flex align-items-center w-fitContent">
            <span className="ms-2">
              <StyledLabel size='14px' weight='400' font="Fredoka, sans-serif">
                {' '}
                  <StyledToolTip title={report?.state} childrenClass={'ms-0'}>
               {report?.state === "Success" ? <TickIcon color={theme.green}/> :
                report?.data?.state === 'Working' ? <ExecutionIcon size={40}/> :
                <ReportFailedIcon size={'12'} color={theme.danger}/>}
                </StyledToolTip>
              </StyledLabel>
            </span>
          </div>
        ),
      },
      {
        id: 2,
        label: 'Execution ID',
        alignBody: 'text-center align-middle ps-4',
        alignHeader: 'text-left align-middle cursor-pointer ps-4 w-auto',
        content: (report) => (
          <div className="d-flex align-items-center w-fitContent">
              <StyledLabel size='14px' weight='500' font="Raleway, sans-serif"    color={theme?.lightBoldBlack}>
                {' '}
                 {report?.uuid.slice(-6)}
              </StyledLabel>
          </div>
        ),
      },
      {
        id: 3,
        path: 'scheduled_dttm',
        label: 'Scheduled at',
        alignBody: 'text-center align-middle',
        alignHeader: 'text-left align-middle cursor-pointer w-auto',
        content: (report) => (
          <div className="d-flex align-items-center w-fitContent">
            <span className="ms-2">
              <StyledLabel size='14px' weight='500' font="Raleway, sans-serif"    color={theme?.lightBoldBlack}>
                {' '}
                 {moment(report?.scheduled_dttm).format('Do MMM YYYY HH:mm:ss')}
              </StyledLabel>
            </span>
          </div>
        ),
      },
      {
        id: 4,
        path: 'start_dttm',
        label: 'Start at',
        alignBody: 'text-center align-middle',
        alignHeader: 'text-left align-middle cursor-pointer',
        content: (report) => (
          <div className="d-flex align-items-center w-fitContent">
              <StyledLabel size='14px' weight='500' font="Raleway, sans-serif"    color={theme?.lightBoldBlack}>
                {' '}
                 {moment(report?.start_dttm).format('Do MMM YYYY HH:mm:ss')}
              </StyledLabel>
          </div>
        ),
      },
//       {
//         id: 5,
//         label: 'Duration',
//         alignBody: 'text-center align-middle ps-3',
//         alignHeader: 'text-left align-middle cursor-pointer ps-4',
//        content: (report) => {
//   const start = moment(report?.start_dttm);
//   const end = moment(report?.end_dttm);

//   const durationMs = end.diff(start); // total milliseconds difference
//   const duration = moment.utc(durationMs).format("HH:mm:ss.SSS"); // format as 00:00:00.295

//   return (
//     <div className="d-flex align-items-center w-fitContent">
//       <span className="ms-2">
//         <StyledLabel
//           size="14px"
//           weight="500"
//           font="Raleway, sans-serif"
//           color={theme?.lightBoldBlack}
//         >
//            {duration}
//         </StyledLabel>
//       </span>
//     </div>
//   );
// }
//       },
       {
        id: 5,
        path: 'value',
        label: 'Value',
        alignBody: 'text-center align-middle ps-3',
        alignHeader: 'text-left align-middle cursor-pointer ps-4',
        content: (report) => (
          <div className="d-flex align-items-center w-fitContent">
            <span className="ms-2">
              <StyledLabel size='14px' weight='500' font="Raleway, sans-serif"    color={theme?.lightBoldBlack}>
                {' '}
                {report?.value}
              </StyledLabel>
            </span>
          </div>
        ),
      },
       {
        id: 5,
        path: 'error_message',
        label: 'Error Message',
        alignBody: 'text-left align-middle ps-3 w-25',
        alignHeader: 'text-left align-middle cursor-pointer ps-4',
        content: (report) => (
          <div className="d-flex align-items-center w-fitContent">
            <span className="ms-2">
              <StyledLabel size='14px' weight='500' font="Raleway, sans-serif"  color={theme?.lightBoldBlack}>
                {' '}
                <StyledToolTip title={report?.error_message} childrenClass={'ms-0'}>
                {report?.error_message?.slice(0, 100)}{report?.error_message?.length > 100 ? '...' : ''}
                </StyledToolTip>
              </StyledLabel>
            </span>
          </div>
        ),
      }
 ]);
    const handlePerPageChange = (perPage) => {
       setFilters((prevState) => ({
         ...prevState,
         perPage: perPage.target.innerText,
         page: 0,
       }));
     };
   
     const handlePageChange = ({ selected }) => {
       setFilters((prevState) => ({
         ...prevState,
         page: selected,
       }));
     };
 const handleSort = (sort) => {
    setFilters((prevState) => ({
      ...prevState,
      sortedColumn: { ...sort },
    }));
  };

  return (
    <>
       <PortletWrapper className='w-100 '>
        <StyledDiv className="portlet__body-bg px-0">
          {isFetching ? (
           <EllipticalLoader height={'10px'}/>
          ) : (
            <PortletBody>
            {reportingList?.data?.length > 0 ? 
            <><Table
                  data={reportingList?.data ?? []}
                  columns={columns}
                  sortColumn={filters.sortedColumn}
                   loading={true}
                  onSort={handleSort}
                />

                <PaginationPerPage
                  perPage={reportingList?.pagination?.perPage || LISTING_PER_PAGE}
                  pageNo={reportingList?.pagination?.page + 1 || 0}
                  onPerPageChange={handlePerPageChange}
                  totalCount={reportingList?.pagination?.total || 0}
                  onPageChange={handlePageChange}
                /></>
              :
               <EmptyState
                    title="No Data"
                    description="There is currently no information to display."
                  />
              }
            </PortletBody>
           )} 
        </StyledDiv>
      </PortletWrapper>
    </>
  );
};
export default ExecutionLog;

const PortletWrapper = styled(Portlet)`
  .portlet-header-subtitle,
  .portlet-header-title {
    font-weight: 400 !important;
    font-size: 32px !important;
    font-family: 'Fredoka', sans-serif;
  }
  .portlet__header-container {
    padding: 16px 24px 0px 24px !important;
  }
`;

const StyledDiv = styled.div`
.lazyLoader__loader{
height:20vh !important;
  background: ${({ theme }) => theme.white};
}
`;